import React, { useEffect, useState, useContext, useRef } from "react";
import { FiSearch } from "react-icons/fi";
import {
  InputGroup,
  Form,
  Button,
  Card,
} from "react-bootstrap";
import { useLocation } from "react-router-dom";
import TenantsList from "../components/tenants/TenantsList";
import NonTenantsList from "../components/tenants/NonTenantsList";
import { Ucontext } from "../context/Ucontext";
import Loading from "../components/loader/Loading";
import Pagination from "../components/Pagination";
import { getTenantDomains } from "../context/functions/AdminFunction";
import Modal from "react-bootstrap/Modal";
import { getEmailDomain } from "../utils/common";
import "../styles/tenants.css";

const Tenants = () => {
  const {
    adminDispatch,
    getSingleUser,
    adminState,
    getAllTenants,
    getTenantJoinedFromList,
  } = useContext(Ucontext);
  const { totalTenants, totalProperties } = adminState;

  const [sortColumn, setSortColumn] = useState(null);
  const [sortType, setSortType] = useState("");
  const [searchVal, setSearchVal] = useState("");
  const [currentPage, setcurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [sortBy, setSortBy] = useState("Latest");
  const [filter, setFilter] = useState({
    digital_verification: "",
    bank_verified: "",
    have_guarantor: "",
    guarantor_scored: "",
    linked_property: "",
    joined_from: "",
  });
  const searchInputRef = useRef(null);

  const location = useLocation();
  // console.log(location.pathname);

  const [routeName, setRouteName] = useState();
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(false);
  const [joinedFromList, setJoinedFromList] = useState([]);
  const [showWorkspaceInfo, setShowWorkspaceInfo] = useState(false);
  const [showWorkspaceInfoLoading, setShowWorkspaceInfoLoading] =
    useState(false);
  const [workspaceInfo, setWorkspaceInfo] = useState([]);
  const abortControllerRef = useRef(null);

  useEffect(() => {
    const controller = new AbortController();
    abortControllerRef.current = controller;

    loadTenants(currentPage, searchVal, sortBy, filter, controller.signal);

    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [currentPage, searchVal, sortBy, filter, sortColumn, sortType]);

  useEffect(() => {
    checkRented();
  }, [totalTenants]);

  useEffect(() => {
    fetchJoinedFromList();
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  const loadTenants = async (currentPage, searchVal, sortBy, filters, signal = null) => {
    setLoading(true);
    const {
      digital_verification = "",
      bank_verified = "",
      have_guarantor = "",
      guarantor_scored = "",
      linked_property = "",
      joined_from = "",
    } = filter;

    let tenants = await getAllTenants(
      currentPage,
      searchVal,
      "rented",
      sortColumn,
      digital_verification,
      bank_verified,
      have_guarantor,
      guarantor_scored,
      linked_property,
      sortType,
      joined_from,
      signal
    );

    if (tenants?.status === "canceled") {
      return;
    }

    if (tenants.status == "Success") {
      await adminDispatch({
        type: "TENANTS_LOADED",
        payload: tenants?.tenants,
      });
      setTotalPages(tenants.totalPages);
    }
    setLoading(false);
  };

  const fetchJoinedFromList = async () => {
    try {
      const response = await getTenantJoinedFromList();
      const data = response.data;
      if (data && data?.success_res?.data) {
        setJoinedFromList(data.success_res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const checkRented = async () => {
    setTenants(totalTenants);
  };

  const handleSort = (sortType) => {
    console.log("HANDLESORT", sortType);
    setSortBy(sortType);
    setcurrentPage(1);
  };

  let interval;
  const handleSearch = (e) => {
    clearTimeout(interval);
    interval = setTimeout(() => {
      setSearchVal(e.target.value);
      setcurrentPage(1);
    }, 500);
  };

  const handlePageChange = (newPage) => {
    if (newPage > 0) {
      setcurrentPage(newPage);
    }
  };
  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    setcurrentPage(event.selected + 1);
  };

  const handleClickFilter = (e) => {
    console.log(e.target.name);
    setFilter((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    setcurrentPage(1);
  };

  const handleSorting = (name) => {
    if (!["fname", "credit_score", "created_at"].includes(name)) {
      return;
    }

    if (name == sortColumn) {
      if (sortType == "asc") {
        setSortType("desc");
      } else {
        setSortType("");
        setSortColumn(null);
      }
    } else {
      setSortType("asc");
      setSortColumn(name);
    }
    console.log(name);
    setcurrentPage(1);
  };

  const handleShowWorkspaceInfo = async (tenant_id) => {
    try {
      setShowWorkspaceInfo(true);
      setShowWorkspaceInfoLoading(true);
      const tenantInfo = await getTenantDomains(tenant_id);
      setWorkspaceInfo(tenantInfo?.data ?? []);
    } catch (error) {
      console.log(error);
    } finally {
      setShowWorkspaceInfoLoading(false);
    }
  };

  return (
    <>
      <div className="tenants-container" style={{
        position:"relative"
      }}>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h4 className="fw-800 mb-1" style={{ color: "var(--tenants-color-text-primary)", fontSize: "22px" }}>Tenants</h4>
            <p className="text-muted small fw-medium mb-0">Manage and view all tenant information</p>
          </div>
        </div>
         {loading ? (
          <div
            style={{
              margin: "auto",
            }}
          >
            <Loading />
          </div>
        ) : null}

        {/* Filters Card */}
        <Card className="tenants-card shadow-sm mb-4">
          <Card.Body className="p-3">
            <div className="tenants-filter-row">
              <div className="tenants-filter-item-wide">
                <span className="tenants-filter-label">Search</span>
                <InputGroup size="sm">
                  <InputGroup.Text className="tenants-search-group-text">
                    <FiSearch size={14} />
                  </InputGroup.Text>
                  <Form.Control
                    className="tenants-search-input"
                    placeholder="Search by name, email, DNI, or passport..."
                    ref={searchInputRef}
                    onChange={handleSearch}
                  />
                </InputGroup>
              </div>

              <div className="tenants-filter-item">
                <span className="tenants-filter-label">Digital Verification</span>
                <Form.Select
                  name="digital_verification"
                  id="digital_verification"
                  size="sm"
                  value={filter.digital_verification}
                  onChange={handleClickFilter}
                  style={{ height: "38px", borderRadius: "6px" }}
                >
                  <option value="">All</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </Form.Select>
              </div>

              <div className="tenants-filter-item">
                <span className="tenants-filter-label">Bank Verified</span>
                <Form.Select
                  name="bank_verified"
                  id="bank_verified"
                  size="sm"
                  value={filter.bank_verified}
                  onChange={handleClickFilter}
                  style={{ height: "38px", borderRadius: "6px" }}
                >
                  <option value="">All</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </Form.Select>
              </div>

              <div className="tenants-filter-item">
                <span className="tenants-filter-label">Have Guarantor</span>
                <Form.Select
                  name="have_guarantor"
                  id="have_guarantor"
                  size="sm"
                  value={filter.have_guarantor}
                  onChange={handleClickFilter}
                  style={{ height: "38px", borderRadius: "6px" }}
                >
                  <option value="">All</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </Form.Select>
              </div>

              <div className="tenants-filter-item">
                <span className="tenants-filter-label">Joined From</span>
                <Form.Select
                  name="joined_from"
                  id="joined_from"
                  size="sm"
                  value={filter.joined_from}
                  onChange={handleClickFilter}
                  style={{ height: "38px", borderRadius: "6px" }}
                >
                  <option value="">All</option>
                  {Array.isArray(joinedFromList) &&
                    joinedFromList.map((joinedFrom) => (
                      <option key={joinedFrom.referredName} value={joinedFrom.referredName}>
                        {joinedFrom.referredName}
                      </option>
                    ))}
                </Form.Select>
              </div>
            </div>
          </Card.Body>
        </Card>

        {/* Tenants List Card */}
        {loading ? null : <Card className="tenants-card shadow-sm mb-4">
          <Card.Header className="bg-white border-0 py-3 px-4 d-flex justify-content-between align-items-center">
            <h6 className="mb-0 fw-800 text-uppercase" style={{ fontSize: "13px", letterSpacing: "0.05em" }}>Tenant List</h6>
            <span className="text-muted small fw-medium" style={{ fontSize: "11px" }}>{tenants.length} rows</span>
          </Card.Header>
          <div className="table-responsive">
            <TenantsList
              loadTenants={loadTenants}
              tenants={tenants}
              sortColumn={sortColumn}
              setSortColumn={setSortColumn}
              sortType={sortType}
              setSortType={setSortType}
              handleSorting={handleSorting}
              currentPage={currentPage}
              searchVal={searchVal}
              sortBy={sortBy}
              filter={filter}
              searchInputRef={searchInputRef}
              handleShowWorkspaceInfo={handleShowWorkspaceInfo}
            />
          </div>
          {tenants.length > 0 && (
            <div className="d-flex justify-content-end p-3 border-top bg-light bg-opacity-50">
              <Pagination
                currentPage={currentPage - 1}
                totalPages={totalPages}
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                className="pagination tenants-pagination mb-0"
              />
            </div>
          )}
        </Card>}

        {/* Workspace Info Modal */}
        <Modal
          show={showWorkspaceInfo}
          onHide={() => setShowWorkspaceInfo(false)}
          centered
          size="md"
        >
          <Modal.Header closeButton className="tenants-modal-header">
            <Modal.Title className="fw-bold h5">Workspace Information</Modal.Title>
          </Modal.Header>
          <Modal.Body className="tenants-modal-body">
            <div className="d-flex flex-column">
              <div className="d-flex justify-content-between workspace-table-header">
                <span>Landlord Name</span>
                <span>Domain</span>
              </div>
              {showWorkspaceInfoLoading ? (
                <div className="text-center py-5">
                  <Loading />
                </div>
              ) : workspaceInfo?.length > 0 ? (
                workspaceInfo.map((workspace) => (
                  <div
                    key={workspace?.landlordName}
                    className="d-flex justify-content-between workspace-table-body"
                  >
                    <span className="fw-600">{workspace?.landlordName}</span>
                    <span className="text-muted">{getEmailDomain(workspace?.email)}</span>
                  </div>
                ))
              ) : (
                <div className="text-center py-5 text-muted">
                  <p className="mb-0">No Data Found!</p>
                </div>
              )}
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default Tenants;
